import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <footer className="bg-gray-900 text-white py-12 mt-12">
            <div className="container mx-auto px-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">

                    {/* Column 1: About Me */}
                    <div>
                        <h4 className="text-xl font-semibold mb-4">About Me</h4>
                        <p className="text-gray-400">
                            Hello, I'm Metehan, just a frontend dev in his own world! Actually, this project was supposed to be completely free. But you know, hosting costs money! Please feel free to reach out to me about what I can add.
                        </p>
                        <div className="mt-4">
                            <button onClick={() => window.open("https://facebook.com", "_blank")} className="text-gray-400 hover:text-white mr-4"><i className="fab fa-facebook"></i></button>
                            <button onClick={() => window.open("https://twitter.com", "_blank")} className="text-gray-400 hover:text-white mr-4"><i className="fab fa-twitter"></i></button>
                            <button onClick={() => window.open("https://instagram.com", "_blank")} className="text-gray-400 hover:text-white mr-4"><i className="fab fa-instagram"></i></button>
                            <button onClick={() => window.open("https://linkedin.com", "_blank")} className="text-gray-400 hover:text-white"><i className="fab fa-linkedin"></i></button>
                        </div>
                    </div>

                    {/* Column 2: Quick Links */}
                    <div>
                        <h4 className="text-xl font-semibold mb-4">Quick Links</h4>
                        <ul className="list-none">
                            <li><Link to="/" className="text-gray-400 hover:text-white block py-1">Home</Link></li>
                            <li><Link to="/blog" className="text-gray-400 hover:text-white block py-1">Blog</Link></li>
                            <li><Link to="/pricing" className="text-gray-400 hover:text-white block py-1">Pricing</Link></li>
                            <li><Link to="/policy" className="text-gray-400 hover:text-white block py-1">Privacy Policy</Link></li>
                            <li><Link to="/terms" className="text-gray-400 hover:text-white block py-1">Terms of Service</Link></li>
                            <li><Link to="/refund" className="text-gray-400 hover:text-white block py-1">Refund Policy</Link></li>
                        </ul>
                    </div>

                    {/* Column 3: Contact Info */}
                    <div>
                        <h4 className="text-xl font-semibold mb-4">Contact Me</h4>
                        <p className="text-gray-400">
                            Email: <a href="mailto:aydometehan@gmail.com" className="text-gray-400 hover:text-white">Get in touch</a>
                        </p>
                    </div>

                </div>

                {/* Bottom Bar */}
                <div className="mt-8 border-t border-gray-700 pt-8">
                    <p className="text-center text-gray-500">
                        © {new Date().getFullYear()} ChatGPT Enhancer. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;